import { List, PenLine } from "lucide-react";
import { useState } from "react";
import { DowntimeReasonPicker } from "./DowntimeReasonPicker";
import { DowntimeKeyboardField } from "./DowntimeKeyboardField";
import type { DowntimeReasonDraft } from "./downtime-reason-queue";
import type { ProductionReason } from "./models";

export function DowntimeReasonChoice({ reasons, draft, onChange, disabled }: {
  reasons: ProductionReason[];
  draft: DowntimeReasonDraft;
  onChange: (draft: DowntimeReasonDraft) => void;
  disabled: boolean;
}) {
  const [query, setQuery] = useState("");
  const chooseCatalogue = (reasonCodeId: string) => onChange({ ...draft, reasonCodeId, customMode: false, customReason: "" });
  return <section className="downtime-reason-choice" aria-label="Duruş nedeni seçimi">
    {!draft.customMode ? <>
      <DowntimeReasonPicker reasons={reasons} value={draft.reasonCodeId} onChange={chooseCatalogue}
        onQueryChange={setQuery} disabled={disabled} />
      <button type="button" className="downtime-custom-action" disabled={disabled}
        onPointerDown={(event) => event.preventDefault()}
        onClick={() => onChange({ ...draft, reasonCodeId: "", customMode: true, customReason: query })}>
        <PenLine size={16} aria-hidden="true" />{query.trim() ? "Bu nedeni kullan" : "Listede yok: özel neden yaz"}
      </button>
    </> : <>
      <DowntimeKeyboardField label={<>Özel duruş adı <small>Zorunlu</small></>}
        keyboardLabel="Özel neden için klavyeyi aç" value={draft.customReason}
        required minLength={3} maxLength={160} disabled={disabled}
        placeholder="Örn. tedarikçi bekleniyor"
        onChange={(customReason) => onChange({ ...draft, reasonCodeId: "", customMode: true, customReason })} />
      <p className="downtime-custom-guidance">Bu duruşa kaydedilir. Ortak listeye eklenmesi amir onayına bağlıdır.</p>
      <button type="button" className="downtime-custom-action" disabled={disabled}
        onClick={() => onChange({ ...draft, customMode: false, customReason: "" })}><List size={16} aria-hidden="true" />Kayıtlı nedenlerden seç</button>
    </>}
  </section>;
}
